/**
 * Administration Hub — card grid linking to admin sub-pages.
 * Route: /administration
 */

import { Link } from 'react-router';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { PageHeader } from '../../components/ui';

interface AdminCard {
  title: string;
  description: string;
  to: string;
  icon: string;
}

const adminCards: AdminCard[] = [
  {
    title: 'User Management',
    description: 'Search users, manage plant access permissions',
    to: '/administration/users',
    icon: '👤',
  },
];

export function AdministrationPage() {
  return (
    <main className="max-w-[1440px] mx-auto px-6 py-8">
      <PageHeader title="Administration" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {adminCards.map((card) => (
          <Link key={card.to} to={card.to} className="no-underline">
            <Card sx={{ height: '100%', '&:hover': { boxShadow: 3, borderColor: 'primary.main' } }}>
              <CardContent>
                <div className="text-3xl mb-2">{card.icon}</div>
                <Typography variant="h2" gutterBottom>{card.title}</Typography>
                <Typography variant="body2" color="text.secondary">{card.description}</Typography>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </main>
  );
}
